import API from "./api";
/* ================= BLOG APIs ================= */

export const getBlogs = async (params = {}) => {
  const query = new URLSearchParams();

  if (Number.isInteger(params.page) && params.page > 0) {
    query.set("page", String(params.page));
  }

  if (Number.isInteger(params.limit) && params.limit > 0) {
    query.set("limit", String(params.limit));
  }

  if (typeof params.status === "string" && params.status.trim()) {
    query.set("status", params.status.trim().toUpperCase());
  }

  const endpoint = query.toString() ? `/blogs?${query.toString()}` : "/blogs";
  const res = await API.get(endpoint);
  return res.data;
};

export const getBlogById = async (id) => {
  const res = await API.get(`/blogs/${id}`);
  return res.data;
};

export const createBlog = async (data) => {
  const res = await API.post("/blogs/create", data);
  return res.data;
};

export const updateBlog = async (id, data) => {
  const res = await API.put(`/blogs/${id}/update`, data);
  return res.data;
};

export const deleteBlog = async (id) => {
  const res = await API.delete(`/blogs/${id}/delete`);
  return res.data;
};

/* ================= IMAGE APIs ================= */

const uploadSingleImage = async (file) => {
  const { data } = await API.post("/images/get-upload-url", {
    fileName: file.name,
    fileType: file.type,
  });

  const { uploadUrl, fileUrl, key } = data;

  const uploadResponse = await fetch(uploadUrl, {
    method: "PUT",
    headers: { "Content-Type": file.type },
    body: file,
  });

  if (!uploadResponse.ok) throw new Error(`S3 upload failed for ${file.name}`);

  const saveResponse = await API.post("/images/save-file", {
    name: file.name,
    url: fileUrl,
    key,
    type: file.type.startsWith("video") ? "video" : "image",
  });

  return saveResponse.data;
};

export const uploadImages = async (files) => {
  return Promise.all(files.map((file) => uploadSingleImage(file)));
};

export const getImages = async () => {
  const res = await API.get("/images");
  return res.data;
};

export const deleteImage = async (id) => {
  const res = await API.delete(`/images/${id}`);
  return res.data;
};
